export default __webpack_public_path__ + "static/media/icon_check_16_Regular_green.60fa449a.svg";